// Module
var code = "<div class=\"repair-view__log\"> <el-row class=\"detail-header-blue\">Лог заказа</el-row> <el-row v-for=\"log in logsRepair\" :key=\"log.id\"> <log-item :logItem=\"log\"></log-item> </el-row> </div> ";
// Exports
module.exports = code;